import { ReactNode } from "react";

import { ColumnMultiValueFilter } from "src/base-components/ColumnFilter";
import { useFilter } from "src/base-components/tableColumnFilters/useFilters";

type OptionsFilterProps = {
  property: string;
  options: { key: string; value: ReactNode }[];
  operator: "contains" | "one_of";
  displayName: string;
  dataLoc?: string;
};

/**
 * Filter based on predefined options
 */
export const OptionsFilter = ({
  property,
  options,
  operator,
  displayName,
  dataLoc,
}: OptionsFilterProps) => {
  const { filters, update, apply, reset, isFiltering, isApplied } = useFilter(
    property,
    [
      {
        key: property,
        operator,
        values: [],
      },
    ],
  );

  const filter = filters[0];

  return (
    <ColumnMultiValueFilter
      dataLoc={dataLoc}
      defaultValue={filter.values}
      headline={`Filter by ${displayName}`}
      isApplied={isApplied()}
      isFiltering={isFiltering({ key: property })}
      options={options}
      values={filter.values}
      onApply={apply}
      onChange={(values) => update([{ ...filter, values }])}
      onResetRequest={() => reset()}
    />
  );
};
